@if (hasSubscribers$ | async) {
  <button mat-icon-button
          (click)="onClick()">
    <mat-icon>menu</mat-icon>
  </button>
}
